import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'PMT/i18n/I18n';

import {
  ProductOption,
  RestaurantMenu
} from 'PMT/entities/menu';

import {
  Utils,
  ArrayUtils,
  StringUtils
} from 'PMT/utils';

import { Modal } from 'react-bootstrap';
import { TextInput } from 'PMT/components/form';
import SearchBox from 'PMT/components/SearchBox';
import SelectProductOptionsModalProductOptionRow from './SelectProductOptionsModalProductOptionRow';

/**
 */
export default class SelectProductOptionsModal extends Component {

  static defaultProps = {
    selectedProductOptions: []
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,

    selectedProductOptions: PropTypes.arrayOf(ProductOption),

    // params: Product
    onUpdate: PropTypes.func.isRequired,
  };

  state = {
    searchQuery: '',

    selectedProductOptions: this.props.selectedProductOptions.slice()
  };

  get productOptionsList(): ProductOption {
    return this.props.productOptionsList;
  }

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  onSubmit = () => {
    this.props.onUpdate(this.state.selectedProductOptions);
  };

  onSearchQueryChange = (searchQuery: string) => {
    this.setState({
      searchQuery
    });
  };

  onProductOptionToggle = (productOption: ProductOption) => {
    const selectedProductOptions = this.state.selectedProductOptions;
    this.setState({
      selectedProductOptions: ArrayUtils.toggleObject(selectedProductOptions, productOption, { id: productOption.id })
    });
  };

  //
  // renderers
  //

  renderOptionsList() {
    const selectedProductOptions = this.state.selectedProductOptions;

    const productOptions = [];
    _.each(this.props.restaurantMenu.options, (productOption:ProductOption) => {
      const query: string = this.state.searchQuery;
      if (_.isEmpty(query) || StringUtils.searchStringOn(query, productOption.name)) {
        productOptions.push(productOption);
      }
    });

    if (_.isEmpty(productOptions) && !_.isEmpty(this.state.searchQuery)) {
      return (
        <p>
          <em>
            {I18n.tr('menu.select_product_option.search_result_empty')}
          </em>
        </p>
      );
    }

    // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
    const sortedOptionsList = _.sortBy(productOptions, ['desc'],
    (productOption: ProductOption): number => {
      return StringUtils.toAlphaNum(productOption.name).toLowerCase();
    });

    return sortedOptionsList.map((productOption: ProductOption) => {
      const isSelected = ArrayUtils.exists(selectedProductOptions, productOption, { id: productOption.id });

      return (
        <SelectProductOptionsModalProductOptionRow
          key={productOption.id}
          productOption={productOption}
          onToggle={this.onProductOptionToggle}
          isSelected={isSelected}
        />
      );
    });
  }

  renderValidationButtons() {
    return (
      <div className="top-buffer-50 text-center">
        <button
          className="btn btn-primary"
          onClick={this.onSubmit}
        >
          {I18n.tr('menu.select_product_option.add_selected_options')}
        </button>
      </div>
    );
  }

  renderBody() {
    try {
    return (
      <div className="select_product_options_modal">
        <SearchBox
          search={this.state.searchQuery}
          onSearchInput={this.onSearchQueryChange}
        />

        <div className="list">
          {this.renderOptionsList()}
        </div>

        {this.renderValidationButtons()}
      </div>
    );
  } catch (e) { console.error(e);}
  }

  render() {
    return (
      <Modal
        bsSize="sm"
        show={this.props.show}
        onHide={this.onHide}
        backdrop="static"
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('menu.select_product_option.select_product_options')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
